const auth = {
  auth: {
    signin: {
      title: "Sign In",
      email: "Email",
      password: "Password",
      remember: "Remember me",
      forgot: "Forgot password?",
      submit: "Sign In",
      create: "Don't have an account?",
      createLink: "Create an account",
    },
    signup: {
      title: "Create an Account",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      terms: "I agree to the terms and conditions",
      submit: "Sign Up",
      login: "Already have an account?",
      loginLink: "Sign in",
    },
    forgot: {
      title: "Forgot Password",
      description: "Enter your email address and we'll send you a link to reset your password.",
      email: "Email",
      submit: "Send Reset Link",
      back: "Back to login",
      success: "Reset link has been sent to your email. Please check your inbox.",
      notFound:
        "We could not find an account with that email. Check the spelling and try again.",
      notFoundHelp:
        "If you have not signed up yet, follow the steps to create an account. Still stuck? See the FAQ or email support.",
      createAccountLink: "How to create an account",
      resetFaqLink: "Password reset help",
      supportEmailLink: "Email support",
    },
    reset: {
      title: "Reset Password",
      description: "Create a new password for your account.",
      password: "New Password",
      confirmPassword: "Confirm Password",
      submit: "Reset Password",
      login: "Back to login",
      success: "Your password has been reset successfully. You will be redirected to the login page.",
      invalidToken: "Invalid or missing reset token. Please request a new password reset link.",
    },
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    rememberMe: "Remember Me",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    signIn: "Sign In",
    signUp: "Sign Up",
    createAccount: "Create Account",
    resetPassword: "Reset Password",
    resetPasswordLink: "Reset Password Link",
    backToSignIn: "Back to Sign In",
    termsAndConditions: "I agree to the Terms and Conditions and Privacy Policy",
    emailSent: "Password reset link has been sent to your email",
    checkEmail: "Please check your email",
    passwordChanged: "Password has been successfully changed",
    signUpSuccess: "Registration successful, please check your email for verification",
    invalidCredentials: "Invalid email or password",
    passwordMismatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 8 characters",
    invalidEmail: "Please enter a valid email address",
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    confirmPasswordRequired: "Please confirm your password",
    termsRequired: "You must agree to the Terms and Conditions and Privacy Policy",
    userNotFound: "User not found",
    emailInUse: "This email is already in use",
    weakPassword: "Password is too weak",
    resetInvalidToken: "Invalid or expired reset token, please request a new password reset link",
    unexpectedError: "An unexpected error occurred, please try again later",
    signinText: "Sign In",
    signupText: "Sign Up",
  },
};

export default auth; 